import Vue from 'vue';
import store from '../../store';
import orderProductTransformer from '../../transformers/orderProduct';

const success = ({ data }, resolve) => {
  const orderProducts = orderProductTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllOrderProducts', orderProducts);
  resolve(orderProducts);
};

const failed = () => {
};


export default orderIds => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/order-products?order_ids=${orderIds.join(',')}`)
    .then((response) => {
      success(response, resolve);
      console.log(response);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/allBulk.js